import * as React from "react";

interface ICheckboxProps {
    value: string | number;
    checked: boolean;
    name: string;
    onChecked(value: string|number, checked: boolean): void;
}

function Checkbox(p: ICheckboxProps) {

    function onCheckChange(event: React.ChangeEvent<HTMLInputElement>) {
        p.onChecked(p.value, event.target.checked);
    }

    return (
        <div className="form-check">
            <label className="form-check-label">
                <input className="form-check-input" type="checkbox" value={p.value} onChange={onCheckChange} checked={p.checked} />
                {p.name}
            </label>
        </div>
    );
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/core/Checkbox/Checkbox.tsx